<div
  class="info-banner"
  [class]="'info-banner--' + variant()"
  role="status"
  [style.--info-banner-bg]="backgroundColor()"
  [style.--info-banner-border]="borderColor()"
  [style.--info-banner-text]="textColor()"
  [style.--info-banner-prompt]="promptColor()"
  [style.--info-banner-font-size]="fontSize()"
  [style.--info-banner-font-family]="fontFamily()"
  [style.--info-banner-font-weight]="fontWeight()"
  [style.--info-banner-letter-spacing]="letterSpacing()"
  [style.--info-banner-padding]="padding()"
  [style.--info-banner-radius]="borderRadius()"
>
  @if (showPrompt()) {
    <span class="info-banner__prompt" aria-hidden="true">&gt;</span>
  }
  <span class="info-banner__text">{{ message() }}</span>
</div>
